































































import CommonBase from "../CommonBase";
import {Component, Inject, Watch} from "vue-property-decorator";
import TopHdr from "./TopHdr.vue";
import Phoneinput from "@/components/phoneinput/Phoneinput.vue";
import BaseApi from "@/store/modules/base";
import rd from "@/modules/vRoutedefs";
import Api from "@/components/prelogin/Api";
import {ApiMessage, IdCard} from "@/modules/models";
import ContactLink from "@/components/shared/ContactLink.vue";

@Component({
    components: {
        "at-top-hdr": TopHdr,
        "at-phone-input": Phoneinput,
        "at-contact-link": ContactLink,
    }
})
export default class NewCustomer extends CommonBase {
    @Inject()
    baseApi!: BaseApi;

    @Inject()
    api!: Api;

    get loggedIn() {
        return this.baseApi.user != null ? this.baseApi.user.person.name : null;
    }

    get employedAt() {
        const user = this.baseApi.user;
        if(user) {
            if (user.employedAt != null) {
                return user.employedAt;
            }
            const latestCard = user.cards.find((card: IdCard, i: number, all: IdCard[]) => all.every((card2) => card.firstReg.millis() >= card2.firstReg.millis()));
            if (latestCard) {
                return latestCard.company;
            }
        }
        return null;
    }

    employedAtInitBlocked: ApiMessage | null = null;

    @Watch("loggedIn", {immediate: true})
    async onLoggedIn() {
        if(this.loggedIn != null) {
            // Check if users employer already has company account, If yes the user probably want to just use the system, not become a new customer.
            if(this.employedAt != null) {
                this.employedAtInitBlocked = await this.api.checkCompanyInitBlocked(this.employedAt.orgNum);
            }

            this.step = 2;
        }
    }

    step = 1;

    get loginTo() {
        return {name: rd.login.missing.name, query: {signup: true, "account-init": true, redir: rd.public.signup.path}};
    }
    get accountInitTo() {
        return {name: rd.company.init.name};
    }
    get startTo() {
        return {name: rd.start.name};
    }
}
